import { useContext } from 'react';
import { VideoViewContext, type VideoViewContextValue } from '../contexts/videoViewContext';

/**
 * This viewer's view of the call: the corner tiles or full screen (#123),
 * and which tile is pinned (#124). Must be used within a `VideoViewProvider`.
 *
 * @example
 * ```tsx
 * const { isFullScreen, exitFullScreen } = useVideoView();
 * ```
 */
export function useVideoView(): VideoViewContextValue {
  const view = useContext(VideoViewContext);
  if (!view) {
    throw new Error('useVideoView must be used within a VideoViewProvider');
  }
  return view;
}
